import { render, staticRenderFns } from "./MessageReplyText.vue?vue&type=template&id=92c64d6a"
import script from "./MessageReplyText.vue?vue&type=script&lang=js"
export * from "./MessageReplyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports